import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriorityLookupComponent } from './priority-lookup.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [PriorityLookupComponent],
  exports: [PriorityLookupComponent],
  providers: []
})
export class PriorityLookupModule { }
